import { render, staticRenderFns } from "./Promet.vue?vue&type=template&id=1028db13&scoped=true&"
import script from "./Promet.vue?vue&type=script&lang=js&"
export * from "./Promet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028db13",
  null
  
)

export default component.exports